import React from 'react'
import { Router } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import { Provider as StoreProvider } from 'react-redux'
import { ThemeProvider } from '@material-ui/styles'
import { renderRoutes } from 'react-router-config'
import { SnackbarProvider } from 'notistack'

import theme from './theme'
import { configureStore } from './redux/store'
import routes from './routes'
import { ScrollReset, GoogleAnalytics, AuthGuard } from './components'
import './mixins/chartjs'
import './assets/css/index.css'
import { Button } from '@material-ui/core'
import ErrorBoundary from 'components/ErrorBoundary'

const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL
})
const store = configureStore()

const App = () => {
  const notistackRef = React.createRef()
  const onClickDismiss = key => () => {
    notistackRef.current.closeSnackbar(key)
  }
  return (
    <ErrorBoundary>
      <StoreProvider store={store}>
        <ThemeProvider theme={theme}>
          <SnackbarProvider
            maxSnack={5}
            ref={notistackRef}
            action={key => (
              <Button color="inherit" onClick={onClickDismiss(key)}>
                Dismiss
              </Button>
            )}>
            <Router history={history}>
              <AuthGuard>
                <ScrollReset />
                <GoogleAnalytics />
                {renderRoutes(routes)}
              </AuthGuard>
            </Router>
          </SnackbarProvider>
        </ThemeProvider>
      </StoreProvider>
    </ErrorBoundary>
  )
}

export default App
